import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import Color from '../../utils/colors';
import { Font, FontWeight } from '../../utils/fonts';

import Analytics from '../../services/Analytics';

import FilledButton from '../FilledButton';
import FadeInAnimation from '../FadeInAnimation';
// import Maze from '../../components/Maze';
import form from '../../components/PopupForm';

class StartScreenDirection extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const {
            handleOpenPopUp,
            scrollToForm,
            extractCheckboxes,
            direction,
        } = this.props;

        handleOpenPopUp(form, { checkboxes: extractCheckboxes() }, scrollToForm);
        Analytics.sendEvent(`go to Form from ${direction} start screen`);
    }

    render() {
        const {
            className,
            extractData,
            handleChangePage,
        } = this.props;

        const {
            // animation,
            headline,
            headlineSmall,
            description = 'lorem ipsum dolor',
            isDescComponent,
        } = extractData();

        return (
            <Root className={className}>
                {/* <MazeStyled animationName={animation} /> */}
                <ContentStyled>
                    <FadeInAnimationStyled
                        delay="1.5"
                        duration="0.9"
                    >
                        <HeadlineSmall>
                            {headlineSmall || 'Исследо\u00ADвание'}
                        </HeadlineSmall>
                    </FadeInAnimationStyled>
                    <FadeInAnimationStyled
                        delay="1.5"
                        duration="0.9"
                    >
                        <Headline>
                            {headline || 'Проектирование'}
                        </Headline>
                    </FadeInAnimationStyled>
                    <FadeInAnimationStyled
                        delay="1.7"
                        duration="0.9"
                    >
                        <Text>
                            {isDescComponent
                                ? description({ handleChangePage })
                                : description}
                        </Text>
                    </FadeInAnimationStyled>
                    <FadeInAnimationStyled
                        delay="1.8"
                        duration="0.9"
                    >
                        <FilledButtonStyled
                            onClick={this.handleClick}
                        >
                            Обсудить задачу
                        </FilledButtonStyled>
                    </FadeInAnimationStyled>
                </ContentStyled>
            </Root>
        );
    }
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    height: 100vh;
    height: ${window.innerHeight}px;

    /* background: #FFFFFF; */

    position: relative;
    overflow: hidden;

    /* @media (min-width: 1441px) {
        width: 100%;
        max-width: 1281px;
        margin: 0 auto;
    } */
`;

const ContentStyled = styled.div`
    max-width: 328px;
    margin: 0 auto;

    ${mediaWidth.m} {
        max-width: 100%;
        margin: initial;
    }
`;

const FadeInAnimationStyled = styled(FadeInAnimation)`
    max-width: 328px;
    margin: 0 auto;

    ${mediaWidth.m} {
        max-width: 100%;
        margin: initial;
        margin-left: 48px;
    }

    ${mediaWidth.l} {
        margin-left: 64px;
    }

    ${mediaWidth.xl} {
        max-width: 1281px;
        margin: 0 auto;
    }
`;

const HeadlineSmall = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: 40px;
    line-height: 40px;

    color: ${Color.TEXT_PRIMARY};
    text-transform: uppercase;

    margin-bottom: 24px;

    ${mediaWidth.m} {
        display: none;
    }
`;

const Headline = styled(HeadlineSmall)`
    display: none;

    ${mediaWidth.m} {
        display: block;

        width: 100%;
        max-width: 100%;

        font-size: 48px;
        line-height: 48px;

        margin-bottom: 24px;
    }

    ${mediaWidth.l} {
        font-size: 48px;
        line-height: 56px;

        margin-bottom: 24px;
    }

    ${mediaWidth.xl} {
        font-size: 56px;
        line-height: 64px;

        margin-bottom: 32px;
    }
`;

const Text = styled.div`
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: 16px;
    line-height: 24px;
    color: #000000;

    opacity: 0.64;

    margin-bottom: 24px;

    ${mediaWidth.m} {
        width: 435px;

        font-size: 18px;
        line-height: 26px;

        margin-bottom: 24px;

        white-space: pre-wrap;
    }

    ${mediaWidth.l} {
        font-size: 18px;
        line-height: 26px;

        margin-bottom: 24px;
    }

    ${mediaWidth.xl} {
        width: 623px;

        font-size: 20px;
        line-height: 28px;

        margin-bottom: 32px;
    }
`;

const FilledButtonStyled = styled(FilledButton)`
    width: 328px;
    height: 63px;

    ${mediaWidth.m} {
        width: 266px;
        height: 63px;
    }

    ${mediaWidth.l} {
        width: 359px;
        height: 71px;
    }

    ${mediaWidth.xl} {
        width: 406px;
        height: 71px;
    }
`;

// const MazeStyled = styled(Maze)`
//     display: none;
//     ${mediaWidth.l} {
//         display: flex;
//     }
// `;

export default StartScreenDirection;
